import React from 'react';
import Reveal from './Reveal';
import SectionLabel from './SectionLabel';

function About() {
  return (
    <section className="indexed-section" id="about">
      <SectionLabel number="01" label="ABOUT" />
      <Reveal className="section-content narrow-copy">
        <p className="eyebrow">The longer route here</p>
        <h2>I didn&apos;t start in marketing.</h2>
        <p>For 12+ years I ran operations for 20+ properties and $6M a year in revenue. Then I moved into paid media, where I now manage $100K+ a month in Meta and Google ads at Active Network and run my own agency, Otso Co.</p>
        <p>But the project I care about most is in my own backyard.</p>
        <p>Laurel is where I live, and great local businesses here were hard to find, on Google and in the AI answers people now search with. So I built Laurel Local Business, a free directory, and a shared postcard that puts owners in their neighbors&apos; mailboxes without paying for a whole mailer alone. Both are below.</p>
      </Reveal>
    </section>
  );
}

export default About;